import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function TermsPage() {
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-524">
      <Navigation data-id="element-525" />

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32" data-id="element-526">
        <article className="prose prose-lg max-w-none" data-id="element-527">
          <h1 className="text-4xl sm:text-5xl font-semibold text-gray-900 mb-8" data-id="element-528">
            Terms of Service
          </h1>

          <p className="text-lg text-gray-700 leading-relaxed mb-8" data-id="element-529">
            Last updated: January 2026
          </p>

          <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-530">
            These Terms of Service ("Terms") govern your access to and use of
            Andoe (the "Service"), including our website, dashboards, reports,
            and related software (collectively, "Andoe," "we," "us," or "our").
            By creating an account, accessing, or using the Service, you agree
            to these Terms. If you do not agree, do not use the Service.
          </p>

          <p className="text-lg text-gray-700 leading-relaxed mb-12" data-id="element-531">
            If you are using the Service on behalf of a company or other
            organization, you represent that you have authority to bind that
            organization to these Terms.
          </p>

          <div className="space-y-12" data-id="element-532">
            <section data-id="element-533">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-534">
                1. Who We Are
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-535">
                Andoe is operated by Grey Timbre AI Ltd ("Company"). We provide
                an analytics platform as a service designed to help users
                understand how brands and content appear in AI-generated answers
                and related discovery experiences.
              </p>
            </section>

            <section data-id="element-536">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-537">
                2. Eligibility and Account Types
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-538">
                Air Plan
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-539">
                Available to individuals for personal or professional use. You
                are responsible for all activity that occurs under your account.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-540">
                If you use Andoe on behalf of an organization, you confirm that
                you have the authority to agree to these Terms on its behalf.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-541">
                Pro Plan
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-542">
                Intended for businesses, teams, and organizations. By using the
                Pro Plan, you confirm that you are authorized to accept these
                Terms and bind your organization, and your organization is
                responsible for all use under its account(s).
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-543">
                We may change plan features, limits, or pricing over time. If a
                change is material, we will provide reasonable advance notice
                (for example, by email or within the Service).
              </p>
            </section>

            <section data-id="element-544">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-545">
                3. Your Account and Security
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-546">
                You are responsible for:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-547">
                <li data-id="element-548">
                  maintaining the confidentiality of your login credentials
                </li>
                <li data-id="element-549">all activity that occurs under your account</li>
                <li data-id="element-550">ensuring information you provide is accurate and lawful</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-551">
                You must notify us promptly if you believe your account has been
                compromised. We may require you to reset credentials or take
                other steps to secure the account.
              </p>
            </section>

            <section data-id="element-552">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-553">
                4. Acceptable Use
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-554">
                You agree to use Andoe only for lawful purposes and in
                accordance with these Terms.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-555">
                You may not:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-556">
                <li data-id="element-557">
                  reverse engineer, decompile, or attempt to extract source
                  code, models, or underlying components of the Service
                </li>
                <li data-id="element-558">
                  attempt to bypass safeguards, rate limits, access controls, or
                  technical restrictions
                </li>
                <li data-id="element-559">
                  access the Service to build a competing product or to
                  benchmark the Service for publication without our written
                  consent
                </li>
                <li data-id="element-560">
                  use Andoe to violate any law, regulation, or third-party
                  rights (including privacy, IP, or contractual rights)
                </li>
                <li data-id="element-561">
                  upload or submit content that is unlawful, misleading,
                  defamatory, infringing, or harmful
                </li>
                <li data-id="element-562">
                  interfere with or disrupt the Service, infrastructure, or
                  security, including by introducing malware or abusive traffic
                </li>
                <li data-id="element-563">attempt to access other users' data or accounts</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-564">
                We may suspend or terminate access if we believe these rules
                have been violated, or if your use creates risk or harm to
                Andoe, other users, or third parties.
              </p>
            </section>

            <section data-id="element-565">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-566">
                5. Data, Inputs, Outputs, and Feedback
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-567">
                5.1 Your Inputs
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-568">
                You retain ownership of the data, prompts, content, and
                materials you submit to Andoe ("Inputs"). You represent and
                warrant that you have all rights necessary to provide Inputs to
                us and to permit us to process them as described in these Terms.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-569">
                You grant Andoe a limited, non-exclusive, worldwide right to
                host, process, store, reproduce, and analyze Inputs solely to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-570">
                <li data-id="element-571">operate and provide the Service</li>
                <li data-id="element-572">generate reports, metrics, and insights for you</li>
                <li data-id="element-573">maintain, protect, and improve the Service</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-574">
                We do not sell your Inputs.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-575">
                5.2 Outputs and Insights
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-576">
                The Service may generate analytics, metrics, scores, reports,
                recommendations, and other outputs ("Outputs"). Outputs are
                provided for informational purposes only.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-577">
                You acknowledge that Outputs:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-578">
                <li data-id="element-579">
                  may be inaccurate, incomplete, out of date, or affected by
                  model updates, personalization, location, time, source
                  availability, or third-party changes
                </li>
                <li data-id="element-580">
                  are not guaranteed to be correct or suitable for any
                  particular purpose
                </li>
                <li data-id="element-581">
                  should not be relied upon as legal, financial, marketing,
                  business, or other professional advice
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-582">
                You are solely responsible for how you interpret and use
                Outputs, including any decisions, actions, or publications based
                on Outputs.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-583">
                5.3 Feedback
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-584">
                If you provide suggestions, ideas, or feedback about the Service
                ("Feedback"), you grant us a non-exclusive, worldwide,
                perpetual, irrevocable, royalty-free right to use Feedback to
                operate, develop, and improve the Service without any obligation
                to you.
              </p>
            </section>

            <section data-id="element-585">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-586">
                6. Third-Party Services and Content
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-587">
                Andoe may interact with or rely on third-party services,
                platforms, APIs, data sources, or models (for example, LLM
                providers, browsers, monitoring tools, or public web content)
                ("Third-Party Services").
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-588">
                Third-Party Services are not under our control and may change,
                degrade, or become unavailable at any time. We are not
                responsible for:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-589">
                <li data-id="element-590">
                  Third-Party Services' availability, accuracy, performance, or
                  security
                </li>
                <li data-id="element-591">changes to AI models or ranking behavior</li>
                <li data-id="element-592">
                  third-party content, citations, or links referenced in Outputs
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-593">
                Your use of Third-Party Services may be subject to their own
                terms, and you are responsible for complying with those terms.
              </p>
            </section>

            <section data-id="element-594">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-595">
                7. No Guarantee of Outcomes
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-596">
                Andoe provides analytics and visibility measurement. We cannot
                guarantee that:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-597">
                <li data-id="element-598">your brand will increase in visibility</li>
                <li data-id="element-599">
                  rankings, mentions, citations, or business outcomes will
                  improve
                </li>
                <li data-id="element-600">
                  any specific result will be achieved by using the Service
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-601">
                You use the Service at your own discretion and risk.
              </p>
            </section>

            <section data-id="element-602">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-603">
                8. Intellectual Property
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-604">
                Andoe and its licensors own all rights, title, and interest in
                and to the Service, including software, interfaces, designs,
                trademarks, documentation, and any aggregated or anonymized
                analytics derived from operation of the Service (excluding your
                Inputs).
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-605">
                Subject to these Terms and your subscription status, we grant
                you a limited, non-exclusive, non-transferable license to access
                and use the Service for your internal business purposes.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-606">
                You may not copy, resell, sublicense, or commercially exploit
                the Service unless expressly authorized in writing.
              </p>
            </section>

            <section data-id="element-607">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-608">
                9. Subscriptions, Fees, Billing, and Taxes
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-609">
                9.1 Billing
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-610">
                Paid plans are billed in advance according to the billing cycle
                shown at purchase and will automatically renew unless you cancel
                before the renewal date.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-611">
                9.2 Cancellation
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-612">
                You may cancel at any time. Unless required by law, cancellation
                takes effect at the end of the current billing period and fees
                are non-refundable.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-613">
                9.3 Taxes
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-614">
                Taxes may apply based on your location. You are responsible for
                applicable taxes, duties, or similar governmental charges,
                except for taxes based on our income.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-615">
                9.4 Late Payments and Chargebacks
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-616">
                Failure to pay may result in suspension or termination. If you
                initiate a chargeback or payment reversal, we may suspend access
                while the dispute is resolved.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-617">
                We may use third-party payment processors, and your payments are
                subject to their terms.
              </p>
            </section>

            <section data-id="element-618">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-619">
                10. Free Trials, Beta Features, and Early Access
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-620">
                We may offer free trials, early access features, or beta
                functionality. These are provided "as is" and may be unstable,
                contain errors, or be modified or discontinued at any time.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-621">
                To the maximum extent permitted by law, we are not responsible
                for any impact caused by reliance on beta or early access
                features.
              </p>
            </section>

            <section data-id="element-622">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-623">
                11. Confidentiality and Security
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-624">
                We use reasonable administrative, technical, and organizational
                measures designed to protect the Service and user data. However,
                no system is perfectly secure, and we cannot guarantee absolute
                security.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-625">
                You are responsible for:
              </p>
              <ul className="space-y-2 text-lg text-gray-700" data-id="element-626">
                <li data-id="element-627">
                  using strong passwords and keeping credentials confidential
                </li>
                <li data-id="element-628">
                  ensuring you have the rights to submit Inputs (including
                  client data)
                </li>
                <li data-id="element-629">
                  not submitting sensitive information unless necessary and
                  permitted (for example, secrets, private keys, regulated
                  personal data)
                </li>
              </ul>
            </section>

            <section data-id="element-630">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-631">
                12. Suspension and Termination
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-632">
                You may stop using Andoe at any time.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-633">
                We may suspend or terminate your access if:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-634">
                <li data-id="element-635">you breach these Terms</li>
                <li data-id="element-636">payment is overdue</li>
                <li data-id="element-637">required by law or regulation</li>
                <li data-id="element-638">
                  your use creates risk or harm to the Service, other users, or
                  third parties
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-639">
                Upon termination:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-640">
                <li data-id="element-641">your right to access the Service ends immediately</li>
                <li data-id="element-642">
                  we may delete your Inputs and account data after a reasonable
                  retention period, and we have no obligation to retain or
                  provide data after termination
                </li>
                <li data-id="element-643">
                  you are responsible for exporting any data you want to keep
                  prior to termination
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-644">
                We may retain certain data as required by law, for security,
                fraud prevention, dispute resolution, or to enforce these Terms.
              </p>
            </section>

            <section data-id="element-645">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-646">
                13. Indemnification
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-647">
                You agree to defend, indemnify, and hold harmless Andoe, its
                affiliates, and its officers, directors, employees, contractors,
                and agents from and against any claims, damages, losses,
                liabilities, costs, and expenses (including reasonable legal
                fees) arising out of or related to:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-648">
                <li data-id="element-649">your Inputs or your use of the Service</li>
                <li data-id="element-650">your violation of these Terms or applicable law</li>
                <li data-id="element-651">
                  your infringement or alleged infringement of any third-party
                  rights (including IP or privacy rights)
                </li>
                <li data-id="element-652">your misuse of Outputs or publication of Outputs</li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-653">
                We may assume control of the defense of any matter subject to
                indemnification, and you agree to cooperate with the defense.
              </p>
            </section>

            <section data-id="element-654">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-655">
                14. Disclaimers
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-656">
                The Service is provided "as is" and "as available." To the
                maximum extent permitted by law, we disclaim all warranties,
                express or implied, including:
              </p>
              <ul className="space-y-2 text-lg text-gray-700" data-id="element-657">
                <li data-id="element-658">merchantability</li>
                <li data-id="element-659">fitness for a particular purpose</li>
                <li data-id="element-660">non-infringement</li>
                <li data-id="element-661">accuracy, completeness, or reliability of Outputs</li>
                <li data-id="element-662">availability, uptime, or uninterrupted operation</li>
              </ul>
            </section>

            <section data-id="element-663">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-664">
                15. Limitation of Liability
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-665">
                To the maximum extent permitted by law:
              </p>
              <ul className="space-y-2 text-lg text-gray-700 mb-4" data-id="element-666">
                <li data-id="element-667">
                  Andoe will not be liable for any indirect, incidental,
                  special, consequential, or punitive damages, or any loss of
                  profits, revenue, data, business, goodwill, or reputational
                  harm
                </li>
                <li data-id="element-668">
                  our total liability for any claim arising out of or related to
                  the Service will not exceed the fees you paid to Andoe in the
                  12 months prior to the event giving rise to the claim
                </li>
              </ul>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-669">
                Some jurisdictions do not allow certain limitations, so portions
                of this section may not apply to you.
              </p>
            </section>

            <section data-id="element-670">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-671">
                16. Dispute Resolution (Arbitration) and Class Action Waiver
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-672">
                16.1 Informal Resolution
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-673">
                Before filing a claim, you agree to try to resolve any dispute
                informally by contacting us at jason@andoe.work. We will attempt
                to resolve the dispute within 30 days.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-674">
                16.2 Binding Arbitration
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-675">
                If a dispute cannot be resolved informally, you and Andoe agree
                that any dispute, claim, or controversy arising out of or
                relating to these Terms or the Service will be resolved by
                binding arbitration, rather than in court, except that either
                party may seek injunctive or equitable relief for misuse of
                intellectual property or unauthorized access.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-676">
                Arbitration will be administered by a recognized arbitration
                provider (such as JAMS or AAA) under its applicable rules. The
                arbitration will be conducted in English by a single arbitrator.
                You agree that the arbitrator may award the same relief a court
                could award, but only to the extent necessary to resolve the
                dispute.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-677">
                16.3 Class Action Waiver
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-678">
                You and Andoe agree that disputes will be brought only on an
                individual basis. You waive any right to participate in a class
                action, class arbitration, or representative proceeding.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-679">
                Some jurisdictions limit or do not allow class action waivers,
                so this section may not apply to you.
              </p>
            </section>

            <section data-id="element-680">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-681">
                17. Governing Law
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-682">
                These Terms are governed by the laws of the Province of British
                Columbia, Canada, and applicable federal laws of Canada, without
                regard to conflict of law principles.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-683">
                Where arbitration is not permitted by law, or where a claim is
                eligible to be heard in court, you agree that disputes will be
                resolved exclusively in the courts located in British Columbia.
              </p>
            </section>

            <section data-id="element-684">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-685">
                18. Changes to These Terms
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-686">
                We may update these Terms from time to time. If changes are
                material, we will provide notice by reasonable means (for
                example, email or within the Service). Continued use of the
                Service after changes take effect constitutes acceptance of the
                updated Terms.
              </p>
            </section>

            <section data-id="element-687">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-688">
                19. General Terms
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-689">
                <strong data-id="element-690">Entire Agreement:</strong> These Terms, along with any
                order form, plan description, or additional policies referenced
                in the Service, are the entire agreement between you and Andoe
                regarding the Service.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-691">
                <strong data-id="element-692">Assignment:</strong> You may not assign these Terms
                without our prior written consent. We may assign these Terms in
                connection with a merger, acquisition, corporate reorganization,
                or sale of assets.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-693">
                <strong data-id="element-694">Severability:</strong> If any provision is found
                unenforceable, the remaining provisions will remain in effect.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-695">
                <strong data-id="element-696">No Waiver:</strong> Failure to enforce any provision is
                not a waiver of our right to do so later.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-697">
                <strong data-id="element-698">Force Majeure:</strong> We are not liable for delays or
                failures caused by events beyond our reasonable control.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-699">
                <strong data-id="element-700">Independent Contractors:</strong> The parties are
                independent contractors. These Terms do not create any
                partnership, employment, or agency relationship.
              </p>
            </section>

            <section data-id="element-701">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-702">
                20. Contact
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-703">
                Questions about these terms:
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-2" data-id="element-704">
                Email: jason@andoe.work
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-2" data-id="element-705">
                Company: Grey Timbre AI Ltd.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-706">
                Country: Canada
              </p>
            </section>
          </div>
        </article>
      </main>

      <Footer data-id="element-707" />
    </div>;
}